import { createContext, useContext, useState } from "react";

const LookupContext = createContext();

export function LookupProvider({ children }) {

    const [lookups, setLookups] = useState(null);

    return (
        <LookupContext.Provider
            value={{ lookups, setLookups }}
        >
            {children}
        </LookupContext.Provider>
    );
}

export function useLookups() {
    return useContext(LookupContext);
}